<template>
  <div class="home h-100">
    <div class="container h-100">
      <div v-if="!suMember" class="h-100">
        <div class="bigButton pb-3 h-25">
          <button class="button font-weight-bold" @click="suMember=true">Southern Union Student, Faculty, or Staff</button>
        </div>
        <div class="bigButton h-25">
          <button class="button font-weight-bold" @click="visitor">Visitor</button>
        </div>
      </div>
      <div class="container py-10 h-100" v-if="suMember">
        <button @click="login" class="h-25 mt-10 font-weight-bold">
          Login with your SU email account
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
const firebase = require("firebase");
// const { format, isBefore } = require('date-fns')
// Required for side-effects
require("firebase/firestore");
// const fb = require('../store/firebaseConfig.js')

export default {
  name: "Home",
  components: {

  },
  data () {
    return {
      suMember: false
    }
  },
  created () {
    if (!firebase.apps.length) {
      firebase.initializeApp({
        apiKey: 'AIzaSyCbB-7CihyBpgzM7p_vmKeA2QQOcmBEH2M',
        authDomain: 'bldg-screen.firebaseapp.com',
        projectId: 'bldg-screen'
      });
    }
  },
  mounted () {
    if (!firebase.apps.length) {
      firebase.initializeApp({
        apiKey: 'AIzaSyCbB-7CihyBpgzM7p_vmKeA2QQOcmBEH2M',
        authDomain: 'bldg-screen.firebaseapp.com',
        projectId: 'bldg-screen'
      });
    }
    // console.log('HOME', 'mounted')
    const vm = this
    firebase.auth().getRedirectResult().then(function(result) {
      if (result.credential) {
        // This gives you a Google Access Token. You can use it to access the Google API.
        var token = result.credential.accessToken;
        // ...
      }
      // The signed-in user info.
      var user = result.user;
      console.log('USER', user.email, user.displayName, user, token)

      if (!['mail.suscc.edu', 'suscc.edu'].includes(user.email.split("@")[1])) {
        throw new Error("Must log in with Southern Union email")
      }

      vm.$router.push('/about')
      // const vm = this
      // vm.db = db
      // user is logged in with a valid account
      // 1. fetch user profile
      // var ref = firebase.database().ref("profiles");
      // console.log("REF", ref)
      // ref.orderByChild("email").equalTo(user.email).on("child_added", function(snapshot) {
      //   console.log("USER FOUND", snapshot.key);
      // });
      // 1a. if user profile doesn't exist, create it
      // 2. Store user and profile data

    }).catch(function(error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      // The email of the user's account used.
      var email = error.email;
      // The firebase.auth.AuthCredential type that was used.
      var credential = error.credential;
      // ...
      console.error("ERROR", errorCode, errorMessage, email, credential)
    });
  },
  udpated () {
    // console.log('HOME', 'updated')
  },
  methods: {
    visitor () {
      // console.log('VISITOR')
      this.$router.push({name: 'Visitor'})
    },
    login () {
      var provider = new firebase.auth.GoogleAuthProvider();
      provider.setCustomParameters({
        'prompt': 'select_account'
      });
      provider.addScope('profile');
      provider.addScope('email');
      firebase.auth().signInWithRedirect(provider)
    }
  }
};
</script>

<style scoped>
.container {
  margin-top: 24px;
}

button {
  padding: 6px;
  background-color: #ffd203;
  color: #1c3195;
  width: 100%;
  height: 100%;
  font-size: 1.2em;
}

</style>
